<template>
  <div class="mg-fixed-bar" :style="{ height }">
    <div class="mg-fixed-bar--body" :style="bodyStyle">
      <el-scrollbar style="flex: 1" :view-style="viewStyle" wrap-style="overflow-y:hidden">
        <slot />
      </el-scrollbar>
      <div class="fixed-bar-right" :class="{ shadow: isHasScroll }">
        <slot name="right" />
      </div>
    </div>
  </div>
</template>

<script>
  import { removeResizeListener, addResizeListener } from 'element-ui/src/utils/resize-event'
  import { throttle } from 'lodash-es'
  export default {
    name: 'MgFixedBar',
    props: {
      position: {
        type: String,
        default: 'top',
        validator: (value) => ['top', 'bottom'].includes(value),
      },
    },
    data() {
      return {
        isHasScroll: false,
        height: 0,
        left: 0,
        top: 0,
      }
    },
    computed: {
      viewStyle() {
        return {
          display: 'flex',
          padding: '10px 0 0',
          alignItems: 'center',
          minHeight: '32px',
        }
      },
      bodyStyle() {
        const style = {
          left: this.left + 'px',
          width: `calc(100% - ${this.left}px)`,
        }
        if (this.position === 'top')
          return {
            ...style,
            top: this.top + 'px',
          }
        return {
          ...style,
          bottom: 0,
        }
      },
    },
    mounted() {
      const handler = () => {
        const el = this.$el.querySelector('.el-scrollbar__wrap')
        this.isHasScroll = el.clientWidth / el.scrollWidth < 1
        this.height = el.clientHeight + 'px'
        this.updatePosition()
      }
      const throttleFn = throttle(handler, 100)
      addResizeListener(this.$el, throttleFn)
      this.$once('hook:beforeDestroy', () => {
        removeResizeListener(this.$el, throttleFn)
      })
    },
    methods: {
      updatePosition() {
        const rect = this.$parent.$el.getBoundingClientRect()
        this.left = rect.left
        this.top = rect.top - 1
      },
    },
  }
</script>

<style lang="scss" scoped>
  .mg-fixed-bar {
    margin-bottom: 10px;
    &--body {
      position: fixed;
      padding: 0 10px;
      z-index: 3;
      box-sizing: border-box;
      background: #fff;
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #ddd;
    }
    .fixed-bar-right {
      display: flex;
      align-items: center;
      padding: 12px 0 12px 10px;
      &.shadow {
        box-shadow: -5px 0px 6px 0px rgba(37, 42, 61, 0.1);
      }
    }
  }
</style>
